var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from '../../globalVue';
import ShopActivityService from '../../api/ShopActivityService';
import Header from './components/Header.vue';
import Add from './Add.vue';
import Detail from './Detail.vue';
import Record from './Record.vue';
var ShopActivityList = (function (_super) {
    __extends(ShopActivityList, _super);
    function ShopActivityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.buttonAuth = {
            Add: false,
            Able: false,
            LookDetail: false,
            LookRecord: false,
            Modify: false,
        };
        return _this;
    }
    ShopActivityList.prototype.created = function () {
        var _this = this;
        this.service = ShopActivityService.getInstance();
        this.getAuth('310004').then(function (pageAuth) {
            Object.assign(_this.buttonAuth, pageAuth && pageAuth.Auth);
        });
    };
    ShopActivityList.prototype.mounted = function () {
        var _this = this;
        this.search();
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    ShopActivityList.prototype.checkSelectIds = function () {
        return (this.selectRows || []).length !== 0;
    };
    ShopActivityList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    ShopActivityList.prototype.publish = function (byType, row) {
        var _this = this;
        if (byType == 'bySelect' && !this.checkSelectIds()) {
            return this.$message.error('请先选择活动！');
        }
        var ids = [];
        switch (byType) {
            case 'bySelect':
                ids = (this.selectRows || []).map(function (item) { return item.activity_id; }).join(",");
                break;
            case 'byRow':
                ids = row && row.activity_id;
                break;
            default:
                break;
        }
        this.$confirm('确定发布该活动吗？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service
                .publish({ activity_ids: ids })
                .then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg || '操作成功');
                window._czc.push([
                    '_trackEvent',
                    '营销活动',
                    '发布活动',
                ]);
                _this.getList();
                _this.selectRows = [];
                _this.$refs.multipleTable && _this.$refs.multipleTable.clearSelection();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    ShopActivityList.prototype.usingActivity = function (row) {
        var _this = this;
        this.$confirm('确定启用该活动吗？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service
                .publish({ activity_ids: row && row.activity_id })
                .then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg || '操作成功');
                window._czc.push([
                    '_trackEvent',
                    '营销活动',
                    '启用活动',
                ]);
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    ShopActivityList.prototype.stopActivity = function (row) {
        var _this = this;
        this.$confirm('确定停用该活动吗？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service
                .stopActivity({ activity_id: row && row.activity_id })
                .then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg || '操作成功');
                window._czc.push([
                    '_trackEvent',
                    '营销活动',
                    '停用活动',
                ]);
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    ShopActivityList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    ShopActivityList.prototype.toPage = function (type, activity_id) {
        var title = null;
        var component = null;
        switch (type) {
            case 'add':
                title = '添加';
                component = Add;
                break;
            case 'edit':
                title = '修改';
                component = Add;
                break;
            case 'detail':
                title = '详情';
                component = Detail;
                break;
            case 'record':
                title = '参与记录';
                component = Record;
                break;
            default:
                break;
        }
        this.addTab({
            component: component,
            title: "\u8425\u9500\u6D3B\u52A8" + title,
            showExist: true,
            name: 'shopActivityList_' + type + activity_id,
            cprops: {
                activity_id: activity_id,
            },
        });
        window._czc.push(['_trackEvent', '营销活动', "\u8425\u9500\u6D3B\u52A8" + title]);
    };
    ShopActivityList.prototype.search = function (filter) {
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        if (pagination) {
            pagination.handleCurrentChange(1);
            return;
        }
        if (filter) {
            this.filter = filter;
        }
        this.getList(currentPager);
    };
    ShopActivityList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(__assign({}, pager, this.filter))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data || [];
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    ShopActivityList = __decorate([
        Component({
            components: {
                'list-header': Header,
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], ShopActivityList);
    return ShopActivityList;
}(Vue));
export default ShopActivityList;
